<button
  type="button"
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  class="inline-flex items-center justify-center rounded-full p-1 disabled:cursor-not-allowed disabled:opacity-40"
  aria-label="Reminders"
  aria-haspopup="dialog"
  [attr.aria-expanded]="isOpen()"
  [disabled]="!canOpen()"
  (click)="open()"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="w-6 h-6"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    />
  </svg>
</button>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayPositions]="positions"
  (backdropClick)="close()"
  (overlayKeydown)="onOverlayKeydown($event)"
>
  <div
    animate.enter="et-elsi-reminder-enter"
    animate.leave="et-elsi-reminder-leave"
    cdkTrapFocus
    cdkTrapFocusAutoCapture
    class="flex w-[300px] max-w-[calc(100vw-2rem)] flex-col gap-3 rounded-lg bg-white p-4 shadow-lg"
    role="dialog"
    aria-labelledby="elsi-reminder-title"
  >
    <div class="flex items-start justify-between gap-2">
      <h2 id="elsi-reminder-title" class="m-0 text-base font-medium">
        Reminders
      </h2>
      <button
        type="button"
        cdkFocusInitial
        class="inline-flex items-center justify-center rounded-full"
        aria-label="Close reminders"
        (click)="close()"
      >
        <img src="assets/icons/close.svg" alt="Close" class="h-3 w-3" />
      </button>
    </div>

    @if (mode() === 'preview' && policy(); as current) {
    <dl class="m-0 grid grid-cols-[1fr_auto] gap-x-4 gap-y-2 text-sm">
      <dt>First delay days</dt>
      <dd class="m-0 text-right">{{ current.firstDelayDays }}</dd>
      <dt>Interval days</dt>
      <dd class="m-0 text-right">{{ current.intervalDays }}</dd>
      <dt>Max rounds</dt>
      <dd class="m-0 text-right">{{ current.maxRounds }}</dd>
      @if (hideSms === false) {
      <dt>Email enabled</dt>
      <dd class="m-0 text-right">{{ current.emailEnabled ? 'Yes' : 'No' }}</dd>
      <dt>SMS enabled</dt>
      <dd class="m-0 text-right">{{ current.smsEnabled ? 'Yes' : 'No' }}</dd>
      }
    </dl>
    @if (current.allowSenderOverride) {
    <button
      type="button"
      class="btn btn-outline btn-sm w-fit self-end rounded-full normal-case min-w-[70px]"
      (click)="showEdit()"
    >
      Edit
    </button>
    } } @else if (mode() === 'edit' && policy(); as current) {
    <et-atoms-elsi-reminder-edit
      [policy]="current"
      (saved)="onSaved($event)"
      (cancelled)="mode.set('preview')"
    ></et-atoms-elsi-reminder-edit>
    }
  </div>
</ng-template>
